module.exports = __webpack_public_path__ + "img/card.750d117a.jpg";